import { createSlice } from "@reduxjs/toolkit";
import { INotificationSlice } from "../../../models/master/notification";


const initialNotificationState: INotificationSlice = {
  notifications:undefined,
  notification:undefined,
  paginationNotification: undefined
};

const notificationSlice = createSlice({
  name: "notification",
  initialState: initialNotificationState,
  reducers: {
    setNotifications: (state, action: { payload: any }) => {
      state.notifications = action.payload;
    },
    setNotification: (state, action: { payload: any }) => {
      state.notification = action.payload;
    },
    setPaginationNotification: (state, action: { payload: any }) => {
      state.paginationNotification = action.payload;
    },
  },
});

export const { setNotifications,setNotification,setPaginationNotification } =
notificationSlice.actions;

const notificationReducers = notificationSlice.reducer;

export type notificationState = ReturnType<typeof notificationReducers>;

export default notificationReducers;
